import { Link } from "react-router-dom";
import { getFeaturedArticle } from "@/lib/news";
import { hotTopics } from "@/mocks/news";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-primary-400",
  down: "ri-arrow-down-line text-secondary-300",
  flat: "ri-subtract-line text-background-400",
};

export default function Hero() {
  const featured = getFeaturedArticle();

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 pt-8 md:pt-12 pb-4">
      <div className="mb-6">
        <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-tight">
          独家吃瓜 · 今日最新动态
        </h1>
        <div className="mt-3 flex flex-wrap items-center gap-3">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-50 border border-primary-200 text-primary-700 text-xs font-label">
            <i className="ri-live-line"></i>
            实时滚动播报
          </span>
          <span className="text-xs text-foreground-500 font-label">
            随时刷新随时有料 · 现场直击一页看完
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <article className="lg:col-span-8 relative rounded-xl overflow-hidden group">
          <div className="w-full h-[320px] md:h-[460px] bg-foreground-900">
            <img
              src={featured.image}
              alt={featured.title}
              title={`${featured.title} - 独家吃瓜`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
            <div className="flex flex-wrap items-center gap-2 mb-3">
              <span className="px-2.5 py-0.5 rounded bg-primary-500 text-background-50 text-[11px] font-label">
                {featured.categoryName}
              </span>
              {featured.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-0.5 rounded bg-background-50/20 text-background-50 text-[11px] font-label backdrop-blur-sm"
                >
                  {tag}
                </span>
              ))}
            </div>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-background-50 leading-snug max-w-2xl">
              <Link to={`/article/${featured.id}`} className="hover:text-accent-300 transition-colors">
                {featured.title}
              </Link>
            </h2>
            <p className="mt-3 text-sm text-background-200 leading-relaxed max-w-2xl line-clamp-2 font-label">
              {featured.excerpt}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-300 font-label">
              <span className="flex items-center gap-1.5">
                <i className="ri-user-line"></i>
                {featured.author}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line"></i>
                {featured.date}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                {featured.readTime}
              </span>
            </div>
          </div>
        </article>

        <aside className="lg:col-span-4 rounded-xl bg-secondary-950 p-5 md:p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="font-heading text-lg font-bold text-background-50 flex items-center gap-2">
              <i className="ri-fire-fill text-accent-500"></i>
              今日热榜
            </h2>
            <span className="text-[11px] text-background-400 font-label">每 10 分钟更新</span>
          </div>
          <ol className="space-y-1">
            {hotTopics.map((topic) => (
              <li key={topic.rank}>
                <Link
                  to={`/article/${topic.articleId}`}
                  className="group flex items-center gap-3 py-2.5 border-b border-background-100/10 last:border-b-0 cursor-pointer"
                >
                  <span
                    className={`shrink-0 w-6 text-center font-heading text-base font-bold ${
                      topic.rank <= 3 ? "text-accent-500" : "text-background-400"
                    }`}
                  >
                    {topic.rank}
                  </span>
                  <span className="flex-1 min-w-0 text-[13px] text-background-100 leading-snug line-clamp-1 group-hover:text-accent-300 transition-colors font-label">
                    {topic.title}
                  </span>
                  <span className="shrink-0 flex items-center gap-1 text-[11px] text-background-400 font-label tabular-nums">
                    {topic.heat}
                    <i className={trendIcon[topic.trend]}></i>
                  </span>
                </Link>
              </li>
            ))}
          </ol>
          <Link
            to="/news"
            className="mt-4 w-full inline-flex items-center justify-center gap-1.5 py-2.5 rounded-md bg-background-100/10 text-background-100 text-sm font-label hover:bg-background-100/20 transition-colors cursor-pointer"
          >
            查看完整热榜
            <i className="ri-arrow-right-line"></i>
          </Link>
        </aside>
      </div>
    </section>
  );
}